// TODO implement AddPaymentInfo event
// TODO check if more values can be passed to product and cart pages

// https://business.twitter.com/en/help/campaign-measurement-and-analytics/conversion-tracking-for-websites.html

/**
 * Add functions for Twitter Ads
 * */

(function (wpm, $, undefined) {

	wpm.loadTwitterPixel = function () {

		try {
			if (wpmDataLayer?.pixels?.twitter?.pixel_id) {

				wpmDataLayer.pixels.twitter.loaded = true;

				// @formatter:off
    			!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
    			},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
    				a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');

    			twq('init', wpmDataLayer.pixels.twitter.pixel_id);
    			// @formatter:on

				twq("track", "PageView")
			}
		} catch (e) {
			console.error(e)
		}
	}

	wpm.twitterGetOrderContentIds = function () {
		let contentIds = []

		for (const [key, item] of Object.entries(wpmDataLayer.order.items)) {

			if (wpmDataLayer?.general?.variationsOutput && 0 !== item.variation_id) {
				contentIds.push(String(wpmDataLayer.products[item.variation_id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type]))
			} else {
				contentIds.push(String(wpmDataLayer.products[item.id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type]))
			}
		}

		return contentIds
	}

}(window.wpm = window.wpm || {}, jQuery));


/**
 * Execute as soon as possible
 * */

(function () {

	jQuery(document).on("wpmLoadPixels", function () {

		if (wpm.canIFire("ads", "twitter-ads") && !wpmDataLayer?.pixels?.twitter?.loaded) wpm.loadTwitterPixel()

	})

})()


/**
 * All event listeners
 * */

// add-to-cart event
jQuery(document).on("wpmAddToCart", function (event, product) {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		twq("track", "AddToCart")
	} catch (e) {
		console.error(e)
	}
})

// view product event
jQuery(document).on("wpmViewItem", function (event, product) {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		twq("track", "ViewContent")
	} catch (e) {
		console.error(e)
	}
})

// // view category event
// jQuery(document).on('wpmCategory', function () {
//
// 	if (!wpmDataLayer?.pixels?.twitter?.loaded) return;
//
// 	// twq('track', 'AddToWishlist');
// });

// add-to-wishlist event
jQuery(document).on("wpmAddToWishlist", function (event, product) {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		twq("track", "AddToWishlist")
	} catch (e) {
		console.error(e)
	}
})

// start checkout event
jQuery(document).on("wpmBeginCheckout", function (event, product) {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		twq("track", "InitiateCheckout")
	} catch (e) {
		console.error(e)
	}
})

// view search event
jQuery(document).on("wpmSearch", function () {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		twq("track", "Search")
	} catch (e) {
		console.error(e)
	}
})


// view order received page event
// TODO find out under which circumstances to use different values in content_type
jQuery(document).on("wpmOrderReceivedPage", function () {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		twq("track", "Purchase", {
			order_id: wpmDataLayer.order.id,
			// content_type: 'product',
			value      : wpmDataLayer.order.value_filtered,
			currency   : wpmDataLayer.order.currency,
			num_items  : wpmDataLayer.order.quantity,
			content_ids: wpm.twitterGetOrderContentIds(),
		})

		// console.log(wpm.twitterGetOrderContentIds())
	} catch (e) {
		console.error(e)
	}
})

